import {defineStore} from 'pinia'
import {get, post, post2, post3, put, put2, $delete} from '@/plugins/axios'
import formController from "@/controller/formController";

export const useHttpStore = defineStore('http', {
    state: () => {
        return {
            url: '',
            bodyType: '',
            headers: [],
            params: [],
            bodies: [],
        }
    },
    getters: {},
    actions: {
        async send(context) {

            return await formController.remoteRequest(context);
        },
    },
    persist: {
        enabled: false
    }
})